import { SearchBookingModel } from './search-booking.model';
import { BookingApproveModel } from './booking-approve.model';
import { SchedulerBookingModel } from './schedular-booking.model';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { SpecialBookingModel } from './../../booking-special/models/special-booking.model';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { BookingOverviewList } from './booking-overviewlist.model';
import { BookingTripDetail, Expense } from './booking-information.model';
import { FreeBooking } from './freebookingmodel';

@Injectable()
export class BookingService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetScheduledBookingList(
    input: SchedulerBookingModel
  ): Observable<IAPIResponse> {
    let getSchedulerBookinUrl = WeGoConfig.API_GET_SCHEDULED_BOOKING_LIST;
    let queryString = this.JQueryHelper.Param(input);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getSchedulerBookinUrl =
      getSchedulerBookinUrl + '?' + decodeURIComponent(queryString);
    return this.http
      .get(getSchedulerBookinUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingList(
    schedulerBookingModel: SchedulerBookingModel,
    input: DataListModel
  ): Observable<IAPIResponse> {
    let getSchedulerBookinUrl = WeGoConfig.API_GET_BOOKING_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringSchedulerBookingModel = this.JQueryHelper.Param(
      schedulerBookingModel
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getSchedulerBookinUrl =
      getSchedulerBookinUrl +
      '?' +
      queryStringDataListModel +
      '&' +
      decodeURIComponent(queryStringSchedulerBookingModel);
    return this.http
      .get(getSchedulerBookinUrl, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleOverview(
    input: SearchBookingModel
  ): Observable<IAPIResponse> {
    let getVehicleOverviewUrl = WeGoConfig.API_GET_VEHICLE_OVERVIEW;
    let queryString = this.JQueryHelper.Param(input);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getVehicleOverviewUrl =
      getVehicleOverviewUrl + '?' + decodeURIComponent(queryString);
    return this.http
      .get(getVehicleOverviewUrl, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public EditBookingDetail(ref: string, isRecurring: boolean) {
    let getEditBookingDetailUrl = WeGoConfig.API_GET_EDIT_BOOKING;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getEditBookingDetailUrl =
      getEditBookingDetailUrl +
      '?referanceID=' +
      ref +
      '&isReccuring=' +
      isRecurring;
    return this.http
      .get(getEditBookingDetailUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public MakeProvisionalBooking(searchBookingModel: SearchBookingModel) {
    let body = searchBookingModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_MAKE_PROVISIONAL_BOOKING, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ConfirmProvisionalBooking(searchBookingModel: SearchBookingModel) {
    let body = searchBookingModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_CONFIRM_PROVISIONAL_BOOKING, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ConfirmRecurringPaymentBooking(
    bookingMasterHashId: string,
    recurringBookingId: string,
    editBookingReferenceId: string = ""
  ) {
    let getUrl = WeGoConfig.API_POST_RECURRING_PAYMENT_BOOKING;

    getUrl = getUrl + '?bookingHashId=' + bookingMasterHashId;

    if (recurringBookingId) {
      getUrl = getUrl + '&recurringBookingId=' + recurringBookingId;
    }
    if (editBookingReferenceId) {
      getUrl = getUrl + '&editBookingReferenceId=' + editBookingReferenceId;
    }

    const options = { headers: this.authService.GetHeader() };

    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public StartInitialPayment(searchBookingModel: SearchBookingModel) {
    let body = searchBookingModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_CREATE_INITIAL_PAYMENT, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public StartInitialPaymentForStartBooking(bookingHashId: string) {
    let getUrl = WeGoConfig.API_START_INITIAL_PAYMENT;

    getUrl =
      getUrl +
      '?provisionalBookingHashId=' +
      bookingHashId +
      '&isFromMobileSide=' +
      false;

    const options = { headers: this.authService.GetHeader() };

    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CancelProvisionalBooking(referanceID: string, isRecurring: boolean) {
    let getCancelProvisionalBooking =
      WeGoConfig.API_GET_CANCEL_PROVISIONAL_BOOKING;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getCancelProvisionalBooking =
      getCancelProvisionalBooking +
      '?referanceID=' +
      referanceID +
      '&isReccuring=' +
      isRecurring;
    return this.http
      .get(getCancelProvisionalBooking, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingOverview(referanceID: string, isRecurring: boolean) {
    let getBookingOverviewUrl = WeGoConfig.API_GET_BOOKING_OVERVIEW;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getBookingOverviewUrl =
      getBookingOverviewUrl +
      '?referanceID=' +
      referanceID +
      '&isReccuring=' +
      isRecurring;
    return this.http
      .get(getBookingOverviewUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingDetails(referanceID: string, isRecurring: boolean) {
    let getBookingDetailsUrl = WeGoConfig.API_GET_BOOKING_Details;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getBookingDetailsUrl =
      getBookingDetailsUrl +
      '?referanceID=' +
      referanceID +
      '&isReccuring=' +
      isRecurring;
    return this.http
      .get(getBookingDetailsUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetAffectedBookingList(
    specialBookingModel: SpecialBookingModel,
    input: DataListModel
  ): Observable<IAPIResponse> {
    let getAffectedBookinUrl = WeGoConfig.API_GET_AFFECTED_BOOKING_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringSchedulerBookingModel = this.JQueryHelper.Param(
      specialBookingModel
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getAffectedBookinUrl =
      getAffectedBookinUrl +
      '?' +
      queryStringDataListModel +
      '&' +
      decodeURIComponent(queryStringSchedulerBookingModel);
    return this.http
      .get(getAffectedBookinUrl, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleList(
    input?: DataListModel,
    ownerCompanyHashID?: string,
    sharedVehicleGroupHashId?: string
  ): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VEHICLE_LIST_SPECIAL_BOOKING;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getVehicleUrl = getVehicleUrl + '?' + queryString;
      if (ownerCompanyHashID)
        getVehicleUrl =
          getVehicleUrl + '&ownerCompanyHashID=' + ownerCompanyHashID;

      if (sharedVehicleGroupHashId)
        getVehicleUrl =
          getVehicleUrl +
          '&sharedVehicleGroupHashId=' +
          sharedVehicleGroupHashId;
    } else {
      if (ownerCompanyHashID)
        getVehicleUrl =
          getVehicleUrl + '?ownerCompanyHashID=' + ownerCompanyHashID;

      if (sharedVehicleGroupHashId)
        getVehicleUrl =
          getVehicleUrl +
          '&sharedVehicleGroupHashId=' +
          sharedVehicleGroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public MakeSpecialBooking(
    specialBookingModel: SpecialBookingModel
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        WeGoConfig.API_POST_MAKE_SPECIAL_BOOKING,
        specialBookingModel,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportBokingList(
    bookingOverviewList: BookingOverviewList,
    input?: DataListModel
  ): any {
    let getUrl = WeGoConfig.API_EXPORT_BOOKING_LIST;
    input.currentPage = 0;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringBookingOverviewModel = this.JQueryHelper.Param(
      bookingOverviewList
    );
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    getUrl =
      getUrl +
      '?' +
      queryStringDataListModel +
      '&' +
      decodeURIComponent(queryStringBookingOverviewModel);
    return this.http.get(getUrl, options);
  }

  public ExportBokingRequestList(
    bookingOverviewList: BookingOverviewList,
    input?: DataListModel
  ): any {
    let getUrl = WeGoConfig.API_EXPORT_BOOKING_REQUEST_LIST;
    input.currentPage = 0;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringBookingOverviewModel = this.JQueryHelper.Param(
      bookingOverviewList
    );
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    getUrl =
      getUrl +
      '?' +
      queryStringDataListModel +
      '&' +
      decodeURIComponent(queryStringBookingOverviewModel);
    return this.http.get(getUrl, options);
  }

  public ExportBokingHistoryList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_BOOKING_HISTORY_LIST + '?' + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public CancelBookings(bookingOverviewList: BookingOverviewList) {
    let body = bookingOverviewList;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_CANCEL_BOOKINGS_LIST, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingOverviewList(
    bookingOverviewList: BookingOverviewList,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getBookingOverviewUrl = WeGoConfig.API_GET_BOOKING_OVERVIEW_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringBookingOverviewModel = this.JQueryHelper.Param(
      bookingOverviewList
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingOverviewUrl =
      getBookingOverviewUrl +
      '?' +
      queryStringDataListModel +
      '&' +
      decodeURIComponent(queryStringBookingOverviewModel);
    return this.http
      .get(getBookingOverviewUrl, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingRequestList(
    bookingRequestList: BookingOverviewList,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getBookingRequestUrl = WeGoConfig.API_GET_BOOKING_REQUEST_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringBookingRequestModel = this.JQueryHelper.Param(
      bookingRequestList
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingRequestUrl =
      getBookingRequestUrl +
      '?' +
      queryStringDataListModel +
      '&' +
      decodeURIComponent(queryStringBookingRequestModel);
    return this.http
      .get(getBookingRequestUrl, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public RevokeOrAbortBookings(bookingOverviewList: BookingOverviewList) {
    let body = bookingOverviewList;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_REVOKE_ABORT_BOOKING, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingHistoryList(input: DataListModel): Observable<IAPIResponse> {
    let getBookingHistoryUrl = WeGoConfig.API_GET_BOOKING_History_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingHistoryUrl =
      getBookingHistoryUrl + '?' + queryStringDataListModel;
    return this.http
      .get(getBookingHistoryUrl, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ApproveBookingRequest(bookingApproveModel: BookingApproveModel) {
    let body = bookingApproveModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_APPROVE_BOOKING_REQUEST, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ApproveRejectMultipleBookingRequest(
    bookingApproveModel: BookingApproveModel
  ) {
    let body = bookingApproveModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        WeGoConfig.API_POST_APPROVE_REJECT_MULTIPLE_BOOKING_REQUEST,
        body,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetActiveDriverList(input?: DataListModel, CompanyHashID: string = ''): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_ACTIVE_DRIVER_LIST_BOOKING;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverUrl = getDriverUrl + '?' + queryString;
    }

    if (CompanyHashID && !queryString) {
      getDriverUrl = getDriverUrl + '?CompanyHashId=' + CompanyHashID;
    } else if (CompanyHashID) {
      getDriverUrl = getDriverUrl + '&CompanyHashId=' + CompanyHashID;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingInformationByHashId(
    bookingHashId: string,
    page: string
  ): Observable<IAPIResponse> {
    let getbookingUrl = WeGoConfig.API_GET_BOOKING_INFORMATION + '?bookingHashId=' + bookingHashId + '&page=' + page;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getbookingUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CheckBookingExtendTime(
    bookingHashId: string
  ): Observable<IAPIResponse> {
    let getbookingUrl =
      WeGoConfig.API_CHECK_BOOKING_EXTEND_TIME +
      '?bookingHashId=' +
      bookingHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getbookingUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }






  public GetHeaderX(accept?: string, content?: string) {
    let acceptType = accept || "application/json";
    let contentType = content || "application/json";
    let access_token = localStorage.getItem("access_token");
    let authorization = access_token ? "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRJZCI6IjI4MGJiYmZlLTY1NjUtMTFlYi04YjlkLTJmYzEzOWRhOWE3MyIsInVzZXJJZCI6ImJiZDhmMzJiLTI0OTctNDVkMi05ZjZmLWFiMzZiZTY3MmY2NiIsImJhY2tvZmZpY2VJZCI6IjE1OTkwIiwicGVybWlzc2lvbnMiOiJBZGFwdGVyR2F0ZXdheS5MaXN0QWRhcHRlcnMsQm9va2luZy5DcmVhdGVCb29raW5nLERhbWFnZS5SZXBvcnREYW1hZ2UsRGFtYWdlLkdldERhbWFnZSxEYW1hZ2UuTGlzdERhbWFnZXMsQm9va2luZy5TdGFydEJvb2tpbmciLCJiYWNrb2ZmaWNlUm9sZUlkcyI6IiIsIm5iZiI6MTY0MTIxODA1NCwiZXhwIjoxNjQxMjQ2ODU0LCJpYXQiOjE2NDEyMTgwNTR9.PH0vGsVCjwu3ndy029pjnFK0z8H23_5ZHEyrvClMse4" : "";
    let language = localStorage.getItem("language");
    let accept_language = language ? language : "en";
    let refresh = localStorage.getItem("refresh_token");
    let refresh_token = refresh ? refresh : "";
    let currentRole = localStorage.getItem("current_role");
    let current_role = currentRole ? currentRole : "";
    let computerId = localStorage.getItem("computerId");

    let headers = new Headers({
      "Content-Type": contentType,
      Accept: acceptType,
      Authorization: authorization,
      "Accept-Language": accept_language,
      RefreshToken: refresh_token,
      CurrentRole: current_role,
      ComputerId: computerId
    });

    return headers;
  }  
  
  public StartBooking(externalId: string) {
    let getbookingUrl = WeGoConfig.GATEWAY_BASE_URL + 'api/booking/v2/' + externalId + '/start';
    let headers = this.authService.GetHeader();
    return this.http
      .put(getbookingUrl, {}, { headers })
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public StopBooking(externalId: string) {
    let getbookingUrl = WeGoConfig.GATEWAY_BASE_URL + 'api/booking/v2/' + externalId + '/stop';
    let headers = this.authService.GetHeader();
    return this.http
      .put(getbookingUrl, {}, { headers })
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExtendOnGoingBooking(
    bookingHashId: string,
    bookingExtendTime: number
  ) {
    let getbookingUrl =
      WeGoConfig.API_EXTEND_ONGOING_BOOKING +
      '?bookingHashId=' +
      bookingHashId +
      '&bookingExtendTime=' +
      bookingExtendTime;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getbookingUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AllowRecurringBooking(
    driverHashId: string,
    organizationHashId: string
  ) {
    let getBookingUrl = WeGoConfig.API_RECURRING_BOOKING_DRIVER;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingUrl =
      getBookingUrl +
      '?driverHashId=' +
      driverHashId +
      '&organizationHashId=' +
      organizationHashId;
    return this.http
      .get(getBookingUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AllowTimeForBooking(driverHashId: string, organizationHashId: string) {
    let getBookingUrl = WeGoConfig.API_ALLOW_TIME_BOOKING_DRIVER;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingUrl =
      getBookingUrl +
      '?driverHashId=' +
      driverHashId +
      '&organizationHashId=' +
      organizationHashId;
    return this.http
      .get(getBookingUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateBookingTrip(bookingTripDetail: BookingTripDetail) {
    let updateBookingTripUrl = WeGoConfig.API_POST_UPDATE_BOOKINGTRIP;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let queryString = this.JQueryHelper.Param(bookingTripDetail);

    updateBookingTripUrl =
      updateBookingTripUrl + '?' + decodeURIComponent(queryString);
    return this.http
      .post(updateBookingTripUrl, bookingTripDetail, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteBookingTrip(bookingTripHashId: string) {
    let getBookingTripUrl =
      WeGoConfig.API_DELETE_BOOKINGTRIP +
      '?bookingTripHashId=' +
      bookingTripHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getBookingTripUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateUserExpense(bookingExpense: Expense) {
    let getUpdateUserExpenseUrl = WeGoConfig.API_UPDATE_USER_EXPENSE;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let queryString = this.JQueryHelper.Param(bookingExpense);

    getUpdateUserExpenseUrl =
      getUpdateUserExpenseUrl + '?' + decodeURIComponent(queryString);
    return this.http
      .post(getUpdateUserExpenseUrl, bookingExpense, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateFreeBooking(freebooking: FreeBooking) {
    let freebookingUrl = WeGoConfig.API_FREE_BOOKING;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let queryString = this.JQueryHelper.Param(freebooking);

    freebookingUrl = freebookingUrl + '?' + decodeURIComponent(queryString);
    return this.http
      .post(freebookingUrl, freebooking, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetAquiredTimeSlots(
    vehicleHashId: string,
    driverHashId: string,
    organizationHashId: string
  ) {
    let getAquiredTimeSlotsUrl = WeGoConfig.API_GET_AQUIRED_TIMESLOT;

    getAquiredTimeSlotsUrl =
      getAquiredTimeSlotsUrl +
      '?vehicleHashId=' +
      vehicleHashId +
      ' &driverHashId=' +
      driverHashId +
      '&organizationHashId=' +
      organizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getAquiredTimeSlotsUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetNormalBookingList(
    input?: DataListModel,
    forSnailTrailReport: boolean = false,
    permission?: string
  ): Observable<IAPIResponse> {
    let getBookingOverviewUrl = WeGoConfig.API_GET_NORMAL_BOOKING_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingOverviewUrl =
      getBookingOverviewUrl +
      '?' +
      queryStringDataListModel +
      '&ForSnailTrailReport=' +
      forSnailTrailReport +
      '&permission=' +
      permission;
    return this.http
      .get(getBookingOverviewUrl, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationList(driverHashId: string, sharedVehicleGroupHashID: string = ''): Observable<IAPIResponse> {
    let getDriverUrl =
      WeGoConfig.API_GET_BOOKING_ORGANIZATION_LIST +
      '?driverHashId=' +
      driverHashId + '&sharedVehicleGroupHashID=' + sharedVehicleGroupHashID;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSpecialPeriodList(
    organizationIdHashID: string,
    driverHashId: string
  ): Observable<IAPIResponse> {
    let getSpecialPeriodListUrl =
      WeGoConfig.API_GET_BOOKING_SPECIAL_PERIODS_LIST +
      "?organizationIdHashID=" +
      organizationIdHashID +
      "&driverHashId=" +
      driverHashId;


    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSpecialPeriodListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVatSettingDropdownList(bookingHashId: string) {
    let getUrl =
      WeGoConfig.API_BOOKINGEXPENSE_VATSETTINGLIST_DROPDOWN +
      '?bookingHashId=' +
      bookingHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVatSettingDefaultValues(bookingHashId: string) {
    const getUrl =
      WeGoConfig.API_BOOKINGEXPENSE_API_GET_VATSETTING_DEFAULT_VALUES +
      '?bookingHashId=' +
      bookingHashId;
    const options = { headers: this.authService.GetHeader() };
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateBookingAfterSuccessfulPayment(
    bookingHashId: string
  ): Observable<IAPIResponse> {
    let getUrl =
      WeGoConfig.API_UPDATE_BOOKING_SUCCESSPAYMENT +
      '?bookingHashId=' +
      bookingHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSharedVehicleGroupListForSpecialBooking(driverHashId: string, companyHashId: string = ''): Observable<IAPIResponse> {
    let getDriverUrl =
      WeGoConfig.API_GET_SPECIAL_BOOKING_SVG_LIST +
      '?driverHashId=' +
      driverHashId + '&companyHashId=' + companyHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/booking.service.ts